export enum ContlerRoles {
  ADMIN = 'admin',
  EMPLOYER = 'employer',
  LEADER = 'leader',
  CHIEF = 'chief',
  GUEST = 'guest',
  SUPER_ADMIN = 'super-admin',
  ADMINISTRATOR = 'administrator',
  INTEGRATION = 'integration',
}
